export const parseNumber = (text: string): number => {
  if (!isValidNumber(text)) {
    return NaN
  }

  const standardizedText = text.replace(/\./g, '').replace(',', '.')

  return Number(standardizedText)
}

export const isValidNumber = (text: string): boolean => {
  const validFormat = /^-?(\d+|\d{1,3}(\.\d{3})*)(,\d+)?$/

  return validFormat.test(text)
}
